import React from "react";
import PropTypes from "prop-types";
import { Icon, Loading } from "signoxe/components/widgets";
import "./styles.scss";
import moment from "moment";
import { callOnEnter } from "signoxe/utils/eventHelpers";
import ta from "time-ago";

const PingSummary = ({
  data,
  handleSearch,
  searchTerm,
  title,
  type,
  interval,
  period,
  handleSelect,
  handleChangePeroid,
  fetchResuults,
  exportToCSV,
  loading,
  sortName,
  handleOrder,
}) => {
  const sortMethods = {
    none: { method: (a, b) => null },
    ascending: {
      method: (a, b) => (a.name > b.name ? -1 : 1),
      method: (a, b) => new Date(a.last_ping) - new Date(b.last_ping),
    },
    descending: {
      method: (a, b) => (a.name > b.name ? 1 : -1),
      method: (a, b) => new Date(b.last_ping) - new Date(a.last_ping),
    },
  };

  return (
    <div className="PingSummary">
      <div className="PingSummary__header">
        <div className="PingTitle">
        <p className="mt-1 hide-for-desktop ">
              {type === "ping" ? (
                <span>
                   <span className="ping" > {(data && data.length) || 0} {" "}</span>
                  {data && data.length > 1 ? "devices" : "device"} {" "}
                  that have <span className="ping">pinged</span> in last{" "}
                </span>
              ) : (
                <span>
                 <span className="not_ping" > {(data && data.length) || 0} {" "}</span>
                  {data && data.length > 1 ? "devices" : "device"}{" "}
                  that have <span className="not_ping">not pinged</span> in last{" "}
                </span>
              )}
          </p>
          
          <div className="flex flex-ai-c flex-jc-c sm-flex-dc">
            <h6 className={ ` hide-for-mobile ${type === "ping" ? "ping" : "not_ping"}`}>
              {(data && data.length) || 0}
            </h6>
            <p className="mt-1 hide-for-mobile">
              {type === "ping" ? (
                <span>
                  {data && data.length > 1 ? "devices" : "device"} {" "}
                  that have <span className="ping">pinged</span> in last{" "}
                </span>
              ) : (
                <span>
                  {data && data.length > 1 ? "devices" : "device"}{" "}
                  that have <span className="not_ping">not pinged</span> in last{" "}
                </span>
              )}
            </p>
            <input
              id="perod"
              name="period"
              type="number"
              className="mt-1 PingSummary_input"
              min="1"
              placeholder="1"
              defaultValue={period}
              onChange={(e) => handleChangePeroid(e)}
              onKeyDown={(e) => handleChangePeroid(handleChangePeroid(e))}
            />

            <select
              className="mt-1 PingSummary_input"
              value={interval}
              onChange={(e) => handleSelect(e)}
            >
              <option value="min">min(s)</option>
              <option value="hour">hour(s)</option>
              <option value="day">day(s)</option>
            </select>
          </div>
        
        </div>


   
        <div className="input-group ping_padding">
          <input
            className="input-group-field border-1"
            type="text"
            value={searchTerm}
            placeholder="Enter device name.."
            onChange={handleSearch}
          />
          <button
            disabled={data && data.length < 1}
            onClick={() => exportToCSV()}
            className="input-group-label pointer border-1"
          >
            <Icon title="Download" name="download" size="1rem" />
          </button>
        </div>
        <div></div>
      </div>
      {loading ? (
        <Loading padTop={false} />
      ) : (
        <div className="PingSummary__content">
          <div className="PingSummary__content__deviceList ">
            <div className="PingSummary__content__deviceListRow header">
              <h5
                className="PingSummary__content__deviceListColum ping_padding cursor"
                onClick={handleOrder}
              >
                Device Name{" "}
                <Icon title="Dropdown" name="caret-down" size="1rem" />
              </h5>
              <div className="PingSummary__content__deviceListColum"></div>
              <h5
                className="PingSummary__content__deviceListColum cursor "
                onClick={handleOrder}
              >
                Last Ping Time{" "}
                <Icon title="Dropdown" name="caret-down" size="1rem" />
              </h5>
            </div>

            {data &&
              data.length > 0 &&
              data
                .filter((item) => {
                  if (searchTerm === "") {
                    return data;
                  } else if (
                    item.name.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return data;
                  }
                })
                .sort(sortMethods[sortName].method)
                .map((item, i) => (
                  <div className="PingSummary__content__deviceListRow" key={i}>
                    <div className="PingSummary__content__deviceListColum ping_padding">
                      {item.name}
                    </div>
                    <div className="PingSummary__content__deviceListColum ">
                      {ta.ago(item.last_ping)}
                    </div>
                  </div>
                ))}
          </div>
        </div>
      )}
    </div>
  );
};

PingSummary.propTypes = {
  devices: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  on: PropTypes.bool.isRequired,
};

export default PingSummary;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PingSummary/index.js